module.exports = __webpack_public_path__ + "static/banner-1-3595f235e6e63a6883de35b9b73bb43d.jpg";